<template>
  <div class="list-antsomi-sync-page">
    <KTCodePreview v-bind:title="'Trạng thái đồng bộ Antsomi'">
      <template v-slot:preview>
        <!-- Header session -->
        <!-- tag-->
        <b-row class="mb-5">
          <b-col md="3">
            <div class="search-col">
              <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.fromDate"
              ></date-picker>
              <span class="ml-1 mr-1"></span>
              <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.toDate"
              ></date-picker>
            </div>
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model.trim="params.referenceId"
              type="text"
              placeholder="ID tham chiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.module"
              :options="listAntsomiSyncModule"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Lọc theo module --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col md="2">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.errorFrom"
              :options="errorFromOptions"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Lọc theo nguồn lỗi --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col md="2">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.status"
              :options="syncStatusOptions"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Trạng thái --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <!--end tag-->
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              variant="primary"
              size="sm"
              class="btn font-weight-bold btn-size"
              @click="onFilter()"
              :disabled="onLoading"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <b-nav class="my-3" tabs pills> </b-nav>
        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listAntsomiSyncStatus"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(status)="row">
            <span
              v-text="ANTSOMI_SYNC_STATUS_NAME[row.item.status]"
              class="label font-weight-bold label-lg label-inline mb-2"
              :class="statusNameClasses(row.item.status)"
              style="width: max-content"
            ></span>
          </template>
          <template v-slot:cell(referenceId)="row">
            <span
              @click="redirectToModuleDetail(row.item)"
              style="cursor: pointer"
              class="text-primary font-weight-bold"
              >{{ row.item.referenceId }}</span
            >
          </template>
          <template v-slot:cell(moduleName)="row">
            <span>{{ syncModuleName[row.item.module] }}</span>
          </template>
          <template v-slot:cell(createdAt)="row">
            <span>{{ formatDate(row.item.createdAt, CLIENT_DATE_TIME) }}</span>
          </template>
          <template v-slot:cell(response)="row">
            <p
              v-if="row.item.response"
              :title="row.item.response"
              v-b-tooltip.hover
            >
              {{ truncateText(row.item.retryResponse || row.item.response) }}
            </p>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item @click="showDetailError(row.item)">
                  <span style="color: #3f4254; font-size: 10px">
                    <i class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="showShowRetryButton(row.item.status)"
                  @click="retrySync(row.item)"
                >
                  <span style="font-size: 10px">
                    <i class="fas fa-redo"></i>
                    &nbsp; Đồng bộ lại
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <!-- End of Table session -->

        <!-- Paginate session -->
        <b-row>
          <b-col>
            <p class="mt-3 text-dark font-weight-bold">
              Hiển thị {{ startIndex }} - {{ endIndex }} trong số
              {{ convertPrice(totalItems) }} bản ghi
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages"
              :linkParams="{}"
              @page-change="fetchData()"
            >
            </BPaginationNavCustom>
          </b-col>
        </b-row>
        <!-- End of Paginate session -->
        <b-modal
          ref="sync-detail-modal"
          hide-footer
          title="Chi tiết đồng bộ"
          size="lg"
        >
          <v-form>
            <div>
              <p>
                <span class="font-weight-bold">ID: </span>{{ previewDetail.id }}
              </p>
              <p>
                <span class="font-weight-bold">Đường dẫn: </span
                >{{ previewDetail.url }}
              </p>
              <p>
                <span class="font-weight-bold">Phương thức: </span
                ><span
                  class="label label-warning label-inline font-weight-bold"
                  >{{ previewDetail.method }}</span
                >
              </p>
              <p v-if="previewDetail.errorFrom">
                <span class="font-weight-bold">Lỗi từ: </span
                ><span
                  class="label label-light-danger label-inline font-weight-bold"
                  >{{
                    getAntsomiSyncErrorFromName(previewDetail.errorFrom)
                  }}</span
                >
              </p>
              <p v-if="previewDetail.retryCount">
                <span class="font-weight-bold">Số lần thử lại: </span
                ><span class="text-danger font-weight-bold">{{
                  previewDetail.retryCount
                }}</span>
              </p>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Thời gian tạo - cập nhật"
                    label-class="font-weight-bold"
                  >
                    {{ formatDate(previewDetail.createdAt, CLIENT_DATE_TIME) }}
                    <i class="text-dark-75 fa fa-arrows-alt-h mx-2"></i>
                    {{ formatDate(previewDetail.updatedAt, CLIENT_DATE_TIME) }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Đầu vào:"
                    label-for="input-json"
                    label-class="font-weight-bold"
                  >
                    <div class="position-relative">
                      <pre id="input-json">{{ previewDetail.payload }}</pre>
                      <b-button
                        variant="light"
                        size="sm"
                        class="copy-btn"
                        @click="
                          copyToClipboard(
                            JSON.stringify(previewDetail.payload, null, 2),
                          )
                        "
                        v-b-tooltip.hover
                        title="Copy"
                      >
                        <i class="fas fa-copy"></i>
                      </b-button>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="pt-5">
                <b-col md="12">
                  <b-form-group
                    label="Kết quả lần đầu:"
                    label-class="font-weight-bold"
                  >
                    <div class="position-relative">
                      <pre id="input-json">{{ previewDetail.response }}</pre>
                      <b-button
                        variant="light"
                        size="sm"
                        class="copy-btn"
                        @click="
                          copyToClipboard(
                            JSON.stringify(previewDetail.response, null, 2),
                          )
                        "
                        v-b-tooltip.hover
                        title="Copy"
                      >
                        <i class="fas fa-copy"></i>
                      </b-button>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="pt-5" v-if="previewDetail.retryResponse">
                <b-col md="12">
                  <b-form-group
                    label="Kết quả thử lại:"
                    label-class="font-weight-bold"
                  >
                    <div class="position-relative">
                      <pre id="input-json">{{
                        previewDetail.retryResponse
                      }}</pre>
                      <b-button
                        variant="light"
                        size="sm"
                        class="copy-btn"
                        @click="
                          copyToClipboard(
                            JSON.stringify(
                              previewDetail.retryResponse,
                              null,
                              2,
                            ),
                          )
                        "
                        v-b-tooltip.hover
                        title="Copy"
                      >
                        <i class="fas fa-copy"></i>
                      </b-button>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group
                label="Đầu vào thử lại"
                label-for="input-json"
                label-class="font-weight-bold"
                v-if="previewDetail.retryPayload"
              >
                <div class="position-relative">
                  <pre id="input-json">{{ previewDetail.retryPayload }}</pre>
                  <b-button
                    variant="light"
                    size="sm"
                    class="copy-btn"
                    @click="
                      copyToClipboard(
                        JSON.stringify(previewDetail.retryPayload, null, 2),
                      )
                    "
                    v-b-tooltip.hover
                    title="Copy"
                  >
                    <i class="fas fa-copy"></i>
                  </b-button>
                </div>
              </b-form-group>

              <div class="text-right">
                <b-button
                  class="mr-2"
                  style="width: 70px"
                  variant="primary"
                  size="sm"
                  @click="hideDetailErrorModal"
                  >Đóng</b-button
                >
                <b-button
                  v-if="showShowRetryButton(previewDetail.status)"
                  style="width: 100px"
                  variant="success"
                  size="sm"
                  @click="retrySync(previewDetail)"
                  >Đồng bộ lại</b-button
                >
              </div>
            </div>
          </v-form>
        </b-modal>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import 'vue-cute-timeline/dist/index.css';
import {
  DP_CONFIG,
  getSubtractDate,
  formatDate,
  CLIENT_DATE_TIME,
} from '@/utils/date';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import {
  ANTSOMI_SYNC_STATUS,
  ANTSOMI_SYNC_ERROR_FROM,
  ANTSOMI_SYNC_MODULE,
  BILL_TYPE,
} from '@/utils/enum';
import {
  ANTSOMI_SYNC_STATUS_NAME,
  ANTSOMI_SYNC_ERROR_FROM_NAME,
} from '@/utils/enum-name';
import { formatDBDate } from '@/utils/date';
import { pickBy, isNil } from 'lodash';
import { makeToastSuccess, handleError, convertPrice } from '@/utils/common';
import { showConfirmNotify } from '@/utils/sweet-alert2';

export default {
  data() {
    return {
      page: 1,
      limit: 10,
      listAntsomiSyncModule: [],
      errorFromOptions: Object.entries(ANTSOMI_SYNC_ERROR_FROM).map(
        ([key, value]) => ({
          id: value,
          key,
          name: ANTSOMI_SYNC_ERROR_FROM_NAME[value],
        }),
      ),
      onLoading: false,
      listAntsomiSyncStatus: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
        },
        {
          key: 'referenceId',
          label: 'ID tham chiếu ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'moduleName',
          label: 'Tên module',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'type',
          label: 'Loại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
          formatter: (value, key, item) => {
            const payload = JSON.parse(item.payload || '{}');
            const ea = payload?.ea;
            const typeMap = {
              sync: 'Tạo',
              update: 'Cập nhật',
            };
            return typeMap[ea] || 'N/A';
          },
        },
        {
          key: 'response',
          label: 'Kết quả',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
        },
        {
          key: 'createdAt',
          label: 'Thời gian tạo',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
        },
      ],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      dpConfigs: DP_CONFIG,
      params: {
        fromDate: getSubtractDate(1),
        toDate: null,
        status: null,
        module: null,
        referenceId: '',
        errorFrom: null,
      },
      totalItems: 0,
      totalPages: 1,
      CLIENT_DATE_TIME,
      ANTSOMI_SYNC_STATUS_NAME,
      syncStatusOptions: Object.entries(ANTSOMI_SYNC_STATUS).map(
        ([key, value]) => ({
          id: value,
          key,
          name: ANTSOMI_SYNC_STATUS_NAME[value],
        }),
      ),
      previewDetail: {},
      syncModuleName: {},
      ANTSOMI_SYNC_ERROR_FROM_NAME,
    };
  },
  methods: {
    redirectToModuleDetail(item) {
      const route = this.getModuleDetailRoute(item);
      if (!route) return;

      const { href } = this.$router.resolve(route);
      window.open(href, '_blank');
    },
    // referenceInfo do BE gắn theo bản ghi gốc (antsomis/sync/status): billType, phoneNo, businessId
    getModuleDetailRoute(item) {
      const referenceId = String(item.referenceId || '');
      const referenceInfo = item.referenceInfo || {};

      switch (item.module) {
        case ANTSOMI_SYNC_MODULE.CUSTOMER:
          // Khách doanh nghiệp: referenceId = b2b_<MST>
          if (referenceId.startsWith('b2b_')) {
            return referenceInfo.businessId
              ? {
                  name: 'update-business',
                  params: { id: referenceInfo.businessId },
                }
              : null;
          }
          return {
            name: 'update-customer',
            query: { id: referenceId, phoneNo: referenceInfo.phoneNo },
          };
        case ANTSOMI_SYNC_MODULE.PRODUCT:
          return { name: 'update-product', query: { id: referenceId } };
        case ANTSOMI_SYNC_MODULE.ORDER:
          return { name: 'edit-order', params: { id: referenceId } };
        case ANTSOMI_SYNC_MODULE.BILL:
          return this.getBillDetailRoute(referenceId, referenceInfo.billType);
        case ANTSOMI_SYNC_MODULE.PRE_ORDER:
          return { name: 'list-pre-order', query: { id: referenceId } };
        case ANTSOMI_SYNC_MODULE.TRADE_IN:
          return { name: 'update-trade-in', query: { id: referenceId } };
        default:
          return null;
      }
    },
    getBillDetailRoute(referenceId, billType) {
      // Hoá đơn tạo từ đơn hàng online được đồng bộ theo mã đơn hàng
      if (referenceId.startsWith('30')) {
        return { name: 'edit-order', params: { id: referenceId } };
      }
      const routeNameByBillType = {
        [BILL_TYPE.WHOLESALE_INVOICE]: 'update-wholesale-invoice',
        [BILL_TYPE.REFUND_INVOICE]: 'update-return-bill',
      };
      return {
        name: routeNameByBillType[billType] || 'update-bill',
        query: { id: referenceId },
      };
    },

    formatDate,
    convertPrice,
    showShowRetryButton(status) {
      return status === ANTSOMI_SYNC_STATUS.ERROR;
    },
    async fetchListAntsomiSyncModule() {
      const {
        data: { data },
      } = await ApiService.get('antsomis/sync/module');
      this.listAntsomiSyncModule = data;
      this.syncModuleName = data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
    async onFilter() {
      this.$route.query.page = 1;
      this.fetchData();
    },
    async fetchData() {
      try {
        if (this.onLoading) return;
        this.onLoading = true;
        const params = this.setParamsFilter();
        const {
          data: { data },
        } = await ApiService.query('antsomis/sync/status', { params });
        this.listAntsomiSyncStatus = data.result;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (error) {
        handleError(error);
      } finally {
        this.onLoading = false;
      }
    },
    setParamsFilter() {
      const page = this.$route.query.page || 1;
      return pickBy(
        {
          ...this.params,
          referenceId: this.params.referenceId?.trim() || undefined,
          fromDate: formatDBDate(this.params.fromDate),
          toDate: formatDBDate(this.params.toDate),
          page,
          limit: this.limit,
        },
        (value) => !isNil(value),
      );
    },
    statusNameClasses(status) {
      const statusClassMapping = {
        [ANTSOMI_SYNC_STATUS.ERROR]: 'label-light-danger',
        [ANTSOMI_SYNC_STATUS.SUCCESS]: 'label-light-success',
        [ANTSOMI_SYNC_STATUS.PROCESSING]: 'label-light-warning',
      };
      return statusClassMapping[status] || 'label-light-info';
    },
    async retrySync(item) {
      try {
        const { isConfirmed } = await showConfirmNotify({
          title: 'Đồng bộ lại',
          text: 'Bạn có chắc muốn đồng bộ lại?',
          actionName: 'Xác nhận',
        });
        if (!isConfirmed) return;
        const {
          data: { data, message },
        } = await ApiService.put(`antsomis/sync/retry/${item.id}`);
        const foundIndex = this.listAntsomiSyncStatus.findIndex(
          ({ id }) => id === item.id,
        );
        Object.assign(this.listAntsomiSyncStatus[foundIndex], data);
        makeToastSuccess(message);
        this.hideDetailErrorModal();
      } catch (error) {
        handleError(error);
      }
    },
    showDetailError(item) {
      this.previewDetail = {
        ...item,
        response: JSON.parse(item.response),
        payload: JSON.parse(item.payload),
        retryResponse: item.retryResponse && JSON.parse(item.retryResponse),
      };
      console.log(this.previewDetail);
      this.$refs['sync-detail-modal'].show();
    },

    hideDetailErrorModal() {
      this.$refs['sync-detail-modal'].hide();
    },

    getAntsomiSyncErrorFromName(errorFrom) {
      return ANTSOMI_SYNC_ERROR_FROM_NAME[errorFrom]?.toUpperCase() || '';
    },
    truncateText(text) {
      const MAX_STRING = 50;
      if (!text || !text.length) {
        return '';
      }
      return text.length < MAX_STRING
        ? text
        : text.substring(0, MAX_STRING) + '...';
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        makeToastSuccess('Đã copy vào clipboard');
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          makeToastSuccess('Đã copy vào clipboard');
        } catch (err) {
          handleError(err);
        }
        document.body.removeChild(textArea);
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Danh sách trạng thái đồng bộ Antsomi',
        route: 'antsomi-sync',
      },
      { title: 'Danh sách trạng thái đồng bộ Antsomi' },
    ]);
  },
  created() {
    this.fetchData();
    this.fetchListAntsomiSyncModule();
  },
  computed: {
    startIndex() {
      return (this.page - 1) * this.limit + 1;
    },
    endIndex() {
      return this.page * this.limit;
    },
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
};
</script>

<style scoped>
.btn-size {
  width: 90px;
}

.icon-size {
  font-size: 1rem;
}

.nav .nav-link {
  color: #3f4254;
  font-weight: 800;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #dddddd96;
  border-radius: 3px;
}

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.search-col {
  display: flex;
  align-items: center;
}

.copy-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 0.25rem 0.5rem;
}

.position-relative {
  position: relative;
}
</style>
<style lang="scss" scoped></style>
